"use client";

import { ChevronDown } from "lucide-react";
import QuerySelect from "./QuerySelect";

import useSWR from "swr";
import { getCountry } from "@/server/user";
import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";

export default function FormPhoneAreaCode(props: {
  value?: string;
  onChange?: (value: string) => void;
}) {
  const locale = useCurrentLocale();

  const { data, isLoading } = useSWR("/api/phone-area-code", async () => {
    const res = await getCountry({
      filter: {
        level: {
          _eq: 1,
        },
        phone_code: {
          _nempty: true,
        },
      },
      fields: "name,phone_code,name_en",
    });

    const areaMap: Record<string, string[]> = {};

    res.data?.forEach((item) => {
      if (item.phone_code) {
        if (!areaMap[item.phone_code]) {
          areaMap[item.phone_code] = [locale === "cn" ? item.name : item.name_en];
        } else {
          areaMap[item.phone_code].push(locale === "cn" ? item.name : item.name_en);
        }
      }
    });

    return Object.keys(areaMap).map((key) => ({
      label: `${areaMap[key].join(" / ")}`,
      value: key,
    }));
  });

  const displayValue = data?.find(
    (option) => option.value === (props.value ?? "86")
  );

  return (
    <QuerySelect
      className="w-40"
      options={data ?? []}
      value={props.value ?? "86"}
      onChange={props.onChange}>
      <div className="relative flex items-center space-x-2 pr-4 text-xs after:absolute after:right-2 after:top-1/2 after:h-4 after:w-px after:-translate-y-1/2 after:bg-[#E5E5E5]">
        {isLoading ? (
          <Skeleton className="h-5 w-20 rounded-sm bg-slate-200" />
        ) : (
          <span>
            +{displayValue?.value} {displayValue?.label}
          </span>
        )}

        <ChevronDown size={16} />
      </div>
    </QuerySelect>
  );
}
